var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.phone)?_c('div',[_c('header-view'),_c('div',{staticClass:"min-width"},[_c('router-view',{key:_vm.$route.fullPath})],1),(!_vm.$route.meta.footerHide)?_c('footer-view'):_vm._e(),_c('login-mask')],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }